import React from "react";

import get from "./get";
import { RowContext, } from "./RowContext";

export const Value = ({
                          path,
                      }) => {

    const ctx =
        React.useContext(RowContext);

    if (!ctx) return null;

    return get(
        ctx.row,
        path
    );
};

export default Value;